import { render } from "./detail.vue?vue&type=template&id=721eb24a&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=721eb24a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-721eb24a"

export default script